"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.colourToneSchema = exports.contentSchema = exports.packSizeSchema = exports.brandSchema = exports.quantitySchema = exports.priceSchema = exports.imperfectionsSchema = exports.qualitySchema = exports.stretchSchema = exports.patternSchema = exports.usesSchema = exports.useSchema = exports.colourSchema = exports.sentenceSetSchema = exports.titleSetLargeSchema = exports.titleSetSmallSchema = exports.widthMMSchema = exports.widthCMSchema = exports.widthLengthBaseSchema = exports.productTypeSchema = void 0;
const yup = __importStar(require("yup"));
const fabricAttributes_1 = require("../attributes/fabricAttributes");
const utils_1 = require("./utils");
const pathFilter_1 = require("./pathFilter");
// Edit paths on error messages
pathFilter_1.setLocale();
const productTypeSchema = (val) => yup.mixed().oneOf([val]).required();
exports.productTypeSchema = productTypeSchema;
exports.widthLengthBaseSchema = yup
    .number()
    .positive()
    .transform(utils_1.NaNtoUndefined)
    .test(utils_1.decimalsTest());
exports.widthCMSchema = exports.widthLengthBaseSchema.max(999).required();
exports.widthMMSchema = exports.widthLengthBaseSchema.max(10).optional();
const toCaseHelper = (str, regExp) => str.replace(regExp, (wrd) => wrd[0].toUpperCase() + wrd.slice(1));
const toTitleCase = (str) => toCaseHelper(str, /[a-zA-Z0-9\-']+/g);
const toSentenceCase = (str) => toCaseHelper(str, /[^.]+/g);
const TITLE_VALID_CHARS = "0-9\\-/'&,%";
// the curly apostrophes is for the ipad which converts a regular apostrophe ' to curly ones ‘ or ’ as part of "Smart Punctuations"
const SENTENCE_VALID_CHARS = "0-9\\-/‘’'&.!,%";
const baseTitleSetSchema = yup
    .string()
    .matches(utils_1.rgx(TITLE_VALID_CHARS, true))
    .trim()
    .transform(toTitleCase);
exports.titleSetSmallSchema = baseTitleSetSchema.max(20);
exports.titleSetLargeSchema = baseTitleSetSchema.max(40);
exports.sentenceSetSchema = yup
    .string()
    .matches(utils_1.rgx(SENTENCE_VALID_CHARS, true))
    .trim()
    .max(75)
    .transform(toSentenceCase);
exports.colourSchema = yup
    .array(exports.titleSetSmallSchema.required())
    .min(1)
    .max(2)
    .required();
exports.useSchema = exports.titleSetLargeSchema
    .trim()
    .required();
exports.usesSchema = yup.array(exports.useSchema).min(1).required();
exports.patternSchema = exports.titleSetLargeSchema.optional();
exports.stretchSchema = exports.sentenceSetSchema.required();
exports.qualitySchema = exports.titleSetLargeSchema;
exports.imperfectionsSchema = yup
    .array(exports.sentenceSetSchema.label('imperfections'))
    .optional()
    .max(3);
exports.priceSchema = yup
    .number()
    .required()
    .transform(utils_1.NaNtoUndefined)
    .test(utils_1.decimalsTest());
exports.quantitySchema = yup
    .number()
    .transform(utils_1.NaNtoUndefined)
    .integer()
    .min(1)
    .max(999);
exports.brandSchema = exports.titleSetLargeSchema;
exports.packSizeSchema = yup
    .number()
    .transform(utils_1.NaNtoUndefined)
    .integer()
    .positive()
    .min(1)
    .max(25)
    .required();
exports.contentSchema = exports.titleSetLargeSchema;
exports.colourToneSchema = utils_1.optSelectOneSchema(Object.values(fabricAttributes_1.ColourTone));
//# sourceMappingURL=sharedSchemas.js.map